module.exports = __webpack_public_path__ + "static/media/logo-silestone.5f4c7460.jpg";